// Generated by scripts/build-info.mjs - do not edit, not committed.
export const BUILD_INFO = {
  sha: '3455f4568bbd3b5dd9bbb7b60916315f8004f830',
  short: '3455f45',
  builtAt: '2026-10-27T10:27:11.600Z',
} as const;
